import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCastle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCastle"><Path d="M8.5 5.5H9.75V3H14.25V5.5H15.5V3H20V5.96973L21.0742 21H14V15H10V21H2.92578L4 5.96973V3H8.5V5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCastle;
